import { Routes } from "@angular/router";

export const AppRoutes: Routes = [
  {
    path: "",
    loadComponent: () =>
      import("./features/diaspobank/diaspobank-landing.component").then(
        (m) => m.DiaspobankLandingComponent,
      ),
    title: "DiaspoBank - La Néobanque de Référence de la Diaspora Africaine",
  },
  {
    path: "investir",
    loadComponent: () =>
      import("./features/investir/investir.component").then(
        (m) => m.InvestirComponent,
      ),
    title: "Devenez investisseur - DiaspoBank",
  },
  {
    path: "**",
    redirectTo: "",
  },
];
